import { render } from "./vcompanypowerset.vue?vue&type=template&id=814999da&scoped=true"
import script from "./vcompanypowerset.vue?vue&type=script&lang=js"
export * from "./vcompanypowerset.vue?vue&type=script&lang=js"

import "./vcompanypowerset.vue?vue&type=style&index=0&id=814999da&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境总后台manage.jsyinba.com/jsgeneral/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-814999da"]])

export default __exports__